// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/control-zones.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/control-zones/control-area-extensions.js';
import g1 from '../lessons/air-law/control-zones/control-zones.js';
import g2 from '../lessons/air-law/control-zones/transition-areas.js';

mount([g0, g1, g2]);
